import { connect } from 'react-redux';

import { Dispatch } from 'redux';
import { ModalState } from 'ia-react-core/~/interfaces/ModalState';
import compose from '../../../utils/components/_compose';
import get from '../../../utils/accessors/get';
import closeModalById from '../../../actions/modal-fn/closeModalById';

import Modal, { ModalComposedProps } from './Modal';

export const mapStateToProps = <Data, >(state: ModalState, { name, isOpened, scope = [] }: ModalComposedProps<Data>) => {
  const isControlled = typeof isOpened !== 'undefined';
  const isOpenedPath = [...scope, name, 'isOpened'].join('.');
  const dataPath = [...scope, name, 'data'].join('.');

  return ({
    isOpened: isControlled ? isOpened : get(state, isOpenedPath),
    data: get(state, dataPath),
    isControlled,
  });
};

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchCloseModalById: (...args: Parameters<typeof closeModalById>) => dispatch(closeModalById(...args)),
});

export default compose<any>(
  connect(mapStateToProps, mapDispatchToProps),
)(Modal);
